// Slug utility for future SEO-friendly slugs.
// Existing slugs are NOT rewritten to keep URLs stable.
export function slugifySeo(input) {
  const raw = String(input || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return raw.toLowerCase().trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);
}

// Canonical mapping: query-string category filters point to the SEO landing.
export const CATEGORY_CANONICAL = {
  // /empresas?category=X → canonicalPath
  onde_comer: "/restaurantes-em-joao-pessoa",
  "onde-comer": "/restaurantes-em-joao-pessoa",
  hoteis: "/hoteis-em-joao-pessoa",
  saude: "/saude-em-joao-pessoa",
  imoveis: "/imoveis-em-joao-pessoa",
  empresas: "/empresas-em-joao-pessoa",
  // /feed?category=X → canonicalPath
  eventos: "/eventos-em-joao-pessoa",
  praias: "/praias-de-joao-pessoa",
  turismo: "/turismo-em-joao-pessoa",
  promocoes: "/promocoes-em-joao-pessoa",
  empregos: "/empregos-em-joao-pessoa",
};

export function canonicalForCategory(cat, fallbackPath) {
  if (!cat || cat === "all") return fallbackPath;
  return CATEGORY_CANONICAL[cat] || fallbackPath;
}

// Bairros with well-known canonical names — used to avoid duplicates in filters.
export const NEIGHBORHOOD_ALIASES = {
  "manaira": "Manaíra",
  "tambau": "Tambaú",
  "cabo branco": "Cabo Branco",
  "bessa": "Bessa",
  "jardim oceania": "Jardim Oceania",
  "aeroclube": "Aeroclube",
};

export function normalizeNeighborhood(n) {
  if (!n) return n;
  const key = String(n).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  return NEIGHBORHOOD_ALIASES[key] || n;
}
